module.exports = __webpack_public_path__ + "f69b200ec6ea5092ac947daf4131a369.MP3";